import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FetchCompanySetting } from "../features/slice";

function ProtectedRoute({ children, requireEvents, requireMembership }) {
  const dispatch = useDispatch();
  const companySettings = useSelector((store) => store.main.companySettings);

  useEffect(() => {
    if (!companySettings) {
      dispatch(FetchCompanySetting());
    }
  }, [dispatch, companySettings]);

  // Only block access if settings are loaded AND the feature is explicitly disabled
  // If settings haven't loaded yet, allow access (don't block the page)
  if (companySettings) {
    // Check if events are required but not enabled
    if (requireEvents && companySettings?.events !== true) {
      return <Navigate to="/dashboard" replace />;
    }

    // Check if membership is required but not enabled
    if (requireMembership && companySettings?.membership !== true) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;
